import LRU from 'lru-cache';
import { getChildren, getDept } from './service';
const lruOptions = {
    max: 10,
};
const lru = new LRU(lruOptions);
export const getSubDeptCacheByKey = async (params) => {
    const cacheResult = lru.get(`expand-${params.value}`);
    if (cacheResult) {
        return cacheResult;
    }
    const expandResult = await getChildren(params);
    lru.set(`expand-${params.value}`, expandResult);
    return expandResult;
};
export const getDeptCacheByKey = async (params) => {
    const cacheResult = lru.get(`info-${params.value}`);
    if (cacheResult) {
        return cacheResult;
    }
    const expandResult = await getDept(params);
    lru.set(`info-${params.value}`, expandResult[0]);
    return expandResult[0];
};
